// extracted by mini-css-extract-plugin
module.exports = {"data_box":"data_box-3Y4LufC1","devide":"devide-1Ea-os9B"};